import React from "react";
import Footer from '../common/footer/footer';
import Header from './../common/header/header';
import "../signup/emailverification.css"
import CommonMessage from './../common/commonMessage';
import  queryString  from 'query-string';
import { Link, Redirect } from 'react-router-dom';

export default class Emailverify extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            isAction : false,
            message:"",
            email: ""
        }
    }
   

    componentDidMount(){
        let params = getQueryVariable("email")
        
            this.setState({
                email : params
            })
       
    }

    redirectToLoginPage = ()=>{
        this.setState({
            redirect:true
        })
       
    }

    render(){
        if(this.state.redirect){
            return <Redirect to = {{
                pathname : "/login",
                state : {
                    fromEmailVerify : true,
                    email : this.state.email
                }
            }}/>
        }
        return (
            <body>
            <Header />
            <div className="full_page_loader" style={{ display: this.state.isAction ? 'block' : 'none' }}>
                <div className="loader_icon"></div>
            </div>
            <main class="static">
                <div id="static_form_wrap">
                    <div class="wrapper">
                        <div class="email_confCtnr">
                            <div class="email_confBox">
                                <h2>Email address verified</h2>
                                <div class="email_confCont">
                                    <i class="email_confIcon"></i>
                                    <p><b>{this.state.email}</b> verification is complete and you can now use your account</p>
                                    <button class="btn-primary" onClick = {()=>this.redirectToLoginPage()} >Login</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
            <CommonMessage message={this.state.message}  isUserSubscribed ={this.state.isUserSubscribed} handler={()=>this.setState({message:''})}/>
            </body>
        )
    }
   
}
function getQueryVariable(variable)
{
        var query = window.location.search.substring(1);
        console.log(query)//"app=article&act=news_content&aid=160990"
        var vars = query.split("&");
        console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
        for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
        if(pair[0] == variable){return pair[1];}
         }
         return(false);
}